var _defs, _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColgate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 253.087,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.35 665.35h182.88v-54.72H-17.35v54.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "scale(-384.23117 384.23117) rotate(-68.6 -.068 1.602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e6b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#8a8889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8889"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(316.60855 0 0 -316.60855 312.391 542.045)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e6b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#8a8889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8889"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "scale(-142.94504 142.94504) rotate(-7 11.28 11.531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(473.42572 0 0 -473.42572 65.211 -74.382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "scale(529.80564 -529.80564) rotate(-23.6 .078 -.664)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "scale(-193.8837 193.8837) rotate(79.2 -1.796 .434)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v684H0V0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(.001 0 0 -.001 297 260.902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba151b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df1a21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.061 272.749L48.31 231.541l.001-.001h64.953l11.75 41.208v.001H60.061zm10.155-5.894h41.497l-24.905-15.694-16.592 15.694zm-6.775-2.923l21.314-20.162 31.82 20.052-7.525-26.388H55.885l7.556 26.498z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7110.16 7289.88H7117.1V-6937.38H-7110.16V7289.88z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.272 236.372l-80.968-29.509-22.251 61.055 80.968 29.508 22.251-61.054z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.468-.668h1.77V.668h-1.77V-.668z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(-48.67073 48.67073) rotate(-20.024 13.99 8.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M138.272 236.372l-80.968-29.509-22.251 61.055 80.968 29.508 22.251-61.054z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.468-.668h1.77V.668h-1.77V-.668z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x2: 1,
    gradientTransform: "scale(-48.67074 48.67074) rotate(-20.024 13.99 8.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d2d2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v684H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v684H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v684H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v684H0V0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "rotate(-90 523.277 157.237) scale(64.93534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.878 469.005h298.08v-298.08h-298.08v298.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.174 444.959h177.12v-185.76h-177.12v185.76z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.728 354.821c0-42.221 34.227-76.449 76.448-76.449 42.222 0 76.449 34.228 76.449 76.449s-34.227 76.449-76.449 76.449c-42.221 0-76.448-34.228-76.448-76.449"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.112-.612h1.224V.612H-.112V-.612z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x2: 1,
    gradientTransform: "scale(152.93688 -152.93688) rotate(75 2.766 -.177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#9a9cb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#9a9cb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#dae8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#a3b3bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#4c3349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a4be"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.118 410.404H359.55v-40.5H258.118v40.5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "matrix(1.25 0 0 -1.25 -27.4 906.903)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M60.061 272.749L48.31 231.541l.001-.001h64.953l11.75 41.208v.001H60.061zm10.155-5.894h41.497l-24.905-15.694-16.592 15.694zm-6.775-2.923l21.314-20.162 31.82 20.052-7.525-26.388H55.885l7.556 26.498z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed192e",
    d: "M999.5.5H.5v252.087h901.307L999.5.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    transform: "matrix(13.33511 0 0 -13.33511 -297.136 7232.895)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88.662 537.189c0 .587.468 1.063 1.064 1.063a1.066 1.066 0 1 0-1.064-1.063m1.852 0c0 .474-.329.788-.788.788-.463 0-.785-.314-.785-.788 0-.476.322-.79.785-.79.46 0 .788.314.788.79m-.289-.558h-.274l-.249.475h-.184v-.475h-.23v1.116h.54c.234 0 .377-.08.377-.342 0-.188-.11-.29-.25-.3l.27-.474zm-.452.688c.116 0 .218 0 .218.118 0 .1-.102.1-.218.1h-.255v-.218h.255z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370.09 38.081l-54.073 139.432h35.871l54.06-139.432h-35.857z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "matrix(13.33511 0 0 -13.33511 -297.136 7232.895)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.144 536.873c-2.724 0-5.721-1.63-6.27-4.377-.585-2.937 2.024-3.566 3.702-3.587 3.773-.046 6.074 2.213 6.599 4.515.503 2.209-1.45 3.449-4.031 3.449m-1.861-6.65c-.65 0-1.114.164-1.393.484-.3.349-.373.886-.228 1.607.264 1.305 1.399 3.245 3.428 3.245.49 0 .856-.14 1.087-.411.272-.316.352-.806.237-1.39-.686-3.364-2.727-3.534-3.131-3.534M64.886 536.623c.99.155 1.92.325 3.727.325 2.898 0 4.68-.958 3.847-3.125-.36-.934-.732-1.911-1.046-2.738-.444-1.151-.347-1.591-.256-2.002 0 0-.677.252-2.098.21-1.272-.033-1.822-.36-3.907-.36-2.253 0-3.08 1.117-2.99 2.298.076 1.036.652 1.937 1.945 2.45.85.34 1.702.454 2.587.522 1.357.108 2.571.05 3.224 0 .121.388.288 1.178-1.62 1.19-2.043.016-3.445-.342-4.089-.541l.676 1.77zm2.115-3.868c-1.423-.15-1.955-.517-2.073-1.203-.099-.55.256-1.058 1.585-1.001.768.034 1.614.222 2.206.519l.658 1.72c-.99.06-1.658.039-2.376-.035M61.434 536.492c-1.382 0-1.444.378-3.698.378-3.233 0-5.889-2.38-6.27-5.007-.117-.828.114-1.568.594-2.088.491-.544 1.238-.751 2.124-.792 1.311-.058 2.51.203 3.66.955-.675-1.996-2.965-2.413-4.51-2.4-.75.005-1.573.037-2.225.349l-.67-1.7c.67-.178 1.677-.294 2.486-.294 3.778 0 6.211 1.35 7.221 4.008l2.58 6.799s-.766-.208-1.292-.208m-5.939-6.074c-1.573 0-1.43 1.529-.875 2.723.706 1.525 2.135 2.226 3.048 2.259.676.026 1.242-.076 1.696-.51-1.067-4.145-3.227-4.472-3.869-4.472M34.95 531.28c-.5-.236-1.682-.59-2.624-.59-2.534 0-3.312 1.54-3.043 3.044.446 2.474 2.833 4.352 5.657 4.352.875 0 1.658-.166 2.348-.45l.832 1.61c-.695.315-1.684.513-2.607.513-4.517 0-8.741-2.578-9.343-6.015-.531-3.034 2.09-4.722 5.3-4.722.864 0 1.82.137 2.615.322l.865 1.936zM78.183 536.93l.567 1.52-2.863-.493-.392-1.028h-1.263l-.46-1.254h1.259l-1.51-3.728c-.386-.943-.403-1.64-.06-2.112.34-.468 1.012-.693 2.048-.693.58 0 1.374.117 1.99.276l.613 1.471c-.35-.14-.907-.286-1.363-.298-.322-.014-.51.055-.63.211-.171.226-.121.674.12 1.287l1.462 3.586h1.88l.486 1.254h-1.884zM86.944 530.822c-.75-.365-2.054-.563-2.923-.563-.758 0-1.378.252-1.747.71-.33.423-.415.978-.252 1.587h6.176l.032.08c.482 1.346.421 2.514-.174 3.286-.543.71-1.487 1.072-2.801 1.072-2.925 0-5.413-1.63-6.058-3.964-.327-1.18-.16-2.212.482-2.988.708-.86 1.958-1.331 3.51-1.331.896 0 1.98.16 2.952.452l.802 1.659zm-2.054 4.809c.493 0 .834-.126 1.023-.37.223-.293.234-.77.03-1.374H82.43c.272.833 1.055 1.744 2.462 1.744"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e1e25",
    d: "M411.53 46.554l-53.274 137.458h-28.057l-2.534 6.468h35.871l55.768-143.926h-7.774z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "matrix(13.33511 0 0 -13.33511 -297.136 7232.895)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9e1e25",
    d: "M67.478 532.267c-1.425-.146-1.956-.52-2.075-1.202-.01-.036-.01-.073-.01-.11.097-.06.252-.115.467-.15.193.54.754.847 2.01.974.304.03.594.053.906.064.06.165.125.34.184.492-.544.005-1.007-.02-1.481-.068M39.137 531.825c-.08-.39-.09-.728-.04-1.01.098-.1.219-.176.372-.238-.014.226.009.48.065.762.266 1.301 1.398 3.244 3.429 3.244.085 0 .164-.005.243-.013a.95.95 0 0 1-.197.433c-.01.01-.025.016-.033.028-.13.025-.26.038-.412.038-2.03 0-3.16-1.94-3.427-3.244M62.455 532.722l1.272 3.344s-.287-.083-.632-.14l-2.475-6.509c-1.013-2.662-3.439-4.015-7.222-4.015-.61 0-1.338.07-1.944.18l-.146-.368c.671-.18 1.681-.296 2.49-.296 3.778 0 6.206 1.353 7.216 4.011l.94 2.47c.051.415.192.881.501 1.323M65.386 534.649l-.168-.411c.498.1.981.155 1.454.19 1.215.096 2.3.06 3.065.01.008.044.026.089.026.128a.39.39 0 0 1-.073.24c-.002.004-.002.006-.007.007a7.04 7.04 0 0 1-1.239.146c-1.519.014-2.3-.125-3.058-.31M59.075 534.829a3.089 3.089 0 0 1-.934.084c-.905-.034-2.336-.734-3.05-2.262-.273-.586-.443-1.252-.355-1.775a.816.816 0 0 1 .371-.188c.01.465.155.996.382 1.476.707 1.529 2.14 2.226 3.047 2.26.158.01.311 0 .454-.008.04.128.075.257.116.39-.01.01-.02.015-.03.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e1e25",
    d: "M52.93 528.8c.49-.542 1.24-.752 2.125-.793.07-.003.135-.003.206-.003.508.142 1.029.366 1.458.713a6.595 6.595 0 0 0-2.061-.224c-.695.032-1.301.172-1.768.494a1.328 1.328 0 0 0-.152.059c.058-.086.119-.168.192-.246M38.45 538.474l-.68-1.327a6.147 6.147 0 0 1-2.35.452c-2.831 0-5.213-1.878-5.66-4.354a2.833 2.833 0 0 1 .06-1.304 1.615 1.615 0 0 1 .372-.403 2.822 2.822 0 0 0-.035 1.219c.44 2.478 2.827 4.354 5.653 4.354.873 0 1.659-.164 2.353-.452l.826 1.608a4.445 4.445 0 0 1-.538.207M34.562 528.852a12.092 12.092 0 0 0-2.616-.32c-1.315 0-2.532.288-3.473.83a5.515 5.515 0 0 0-.596.297c.973-1.052 2.618-1.616 4.462-1.616.863 0 1.824.14 2.619.325l.86 1.936a5.858 5.858 0 0 0-.732-.267l-.524-1.184z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e1e25",
    d: "M758.153 62.454l-2.827 7.4h7.721l3.36-8.8-8.254 1.4z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "matrix(13.33511 0 0 -13.33511 -297.136 7232.895)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9e1e25",
    d: "M77.975 528.933c-.616-.162-1.41-.282-1.99-.282-.815 0-1.397.141-1.774.425a.921.921 0 0 1 .12-.217c.335-.467 1.012-.692 2.046-.692.584 0 1.377.118 1.994.281l.606 1.464v.006a4.4 4.4 0 0 0-.68-.209l-.322-.776zM72.95 535.108c.251-.462.262-1.05-.016-1.77-.357-.934-.73-1.911-1.044-2.74-.44-1.15-.345-1.594-.253-2.002 0 0-.688.249-2.108.21-1.267-.034-1.817-.362-3.902-.362-.964 0-1.663.205-2.15.532-.047.022-.098.039-.145.058.417-.626 1.265-1.08 2.692-1.08 2.083 0 2.633.327 3.905.366 1.418.04 2.098-.21 2.098-.21-.088.408-.185.849.255 2.004.318.823.69 1.799 1.05 2.737.382 1.002.206 1.747-.383 2.257M47.044 532.444v.002c.23.997-.046 1.795-.646 2.375.313-.513.42-1.145.253-1.888-.53-2.3-2.824-4.56-6.603-4.512-.81.01-1.836.163-2.614.65-.1.038-.205.088-.3.133.746-.988 2.224-1.257 3.313-1.27 3.024-.036 5.1 1.41 6.073 3.167l.524 1.343zM80.882 535.816l.055.138h-.58l-.296-.767h-1.885c-.219-.532-1.46-3.586-1.46-3.585a3.224 3.224 0 0 1-.214-.773.854.854 0 0 1 .235-.016c.09.004.182.014.272.024.031.09.062.18.103.276 0 0 1.243 3.055 1.457 3.588h1.207c.305.416.68.789 1.106 1.115M85.74 535.109a1.822 1.822 0 0 1-.371.032c-1.002 0-1.692-.462-2.097-1.028h.86c.399.322.937.54 1.633.54h.095v.006c0 .046 0 .095-.007.135a.64.64 0 0 1-.112.315M88.93 534.948a2.85 2.85 0 0 1-.255.278c.457-.77.476-1.85.03-3.077l-.03-.081h-6.177c-.09-.345-.104-.672-.034-.966.047-.06.1-.113.155-.165a1.577 1.577 0 0 1 .206-.149 2.12 2.12 0 0 0 .072.794h6.172l.03.08c.484 1.347.425 2.512-.168 3.286M86.616 528.675a10.693 10.693 0 0 0-2.95-.451c-1.09 0-2.021.229-2.731.666-.134.053-.26.11-.38.173.71-.857 1.956-1.326 3.506-1.326.895 0 1.973.16 2.952.454l.802 1.657a4.848 4.848 0 0 0-.764-.276l-.435-.897z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    transform: "matrix(1.25 0 0 -1.25 -27.4 906.903)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M230.728 354.821c0-42.221 34.227-76.449 76.448-76.449 42.222 0 76.449 34.228 76.449 76.449s-34.227 76.449-76.449 76.449c-42.221 0-76.448-34.228-76.448-76.449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColgate);
export default __webpack_public_path__ + "static/media/colgate.1476b227f3d9221ddea4e456cfac56d0.svg";
export { ForwardRef as ReactComponent };